import {
	ApButtonDanger,
	ApButtonMain,
	ApButtonSecondary,
	colors,
} from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
	margin: 8px 0 0 0;
	padding: 0 10px;
	gap: 6px;
`;

export const HeaderWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const Heading = styled.div`
	font-weight: 500;
	font-size: 16px;
	color: ${colors.black};
`;

export const Note = styled.div`
	font-size: 14px;
	color: ${colors.black};
	.note_heading {
		font-weight: bold;
	}
`;

export const Note2 = styled.div`
	font-size: 14px;
	color: ${colors.black};
	margin-left: 37px;
	display: flex;
	gap: 3px;
`;

export const MappingViewWrapper = styled.div`
	margin: 12px 0 12px 0;
`;

export const ColumnContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	margin: 0 0 16px 0;
`;

export const SourceLabel = styled.label``;
// color: ${props =>
// 	props.required ? `${colors.red600}` : `${colors.grey700}`};
// width: 250px;

export const ErrorText = styled.p`
	color: ${colors.red600};
	font-size: 12px;
`;

export const StyledSelect = styled.select`
	width: 200px;
	padding: 10px;
	font-size: 16px;
  color: ${colors.grey700}
	border: 1px solid ${colors.grey300};
	background-color: ${colors.white};
	cursor: pointer;
	outline: none;

	&:focus,
	&:hover {
		border-color: ${colors.grey500};
	}
`;

export const ActionsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`;

export const PaginationWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

export const SubActionsWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 10px;
`;

export const RemoveCustomColumn = styled(ApButtonDanger)``;

export const AddCustomColumn = styled(ApButtonSecondary)``;

export const SaveMapping = styled(ApButtonMain)``;

export const InfoWrapper = styled.div`
	width: 250px;
	display: flex;
	gap: 4px;
`;

export const IconWrapper = styled.div`
	height: 16px;
	width: 16px;
`;

export const ColumnDescriptionTooltip = styled.p`
	text-align: left;
	font-size: 12px;
	padding: 2px;
`;
